/**
 * Splits a question-label line ("Q <label>: <question text>") into its standalone
 * label (the variable name) and the question wording. The split is on the FIRST
 * colon after the leading "Q", matching how the questionnaire parser reads it.
 *
 * @param content - A question label content line
 * @returns The standalone label and the question text (both trimmed)
 */
export const parseQuestionLabel = (
  content: string
): { label: string; text: string } => {
  const match = content.match(/^Q\s+(.+?):([\s\S]*)$/)
  if (!match) {
    // Not in canonical form — treat everything after a leading "Q " as the label.
    return { label: content.replace(/^Q\s+/i, "").trim(), text: "" }
  }
  return { label: match[1].trim(), text: match[2].trim() }
}

/**
 * Rebuilds a question-label content line from a standalone label and question text.
 *
 * @param label - The standalone label (variable name)
 * @param text - The question wording
 * @returns A "Q <label>: <text>" content line
 */
export const buildQuestionLabel = (label: string, text: string): string => {
  return `Q ${label.trim()}: ${text.trim()}`
}
